
export default {
    'add-new-salary': 'Add new salary',
    'use-excel-file': 'Use excel file',
    'rebates': 'Rebates',
    'salary-is-added': 'Salary is added',
    'salary-is-edited': 'Salary is edited'
}